module.exports = __webpack_public_path__ + "img/msra.b0fea5b.png";